module.exports = __webpack_public_path__ + "static/media/signal.1453dcb7.svg";